<template>
  <section class="box">
    <h2>
      <span class="main-color bold">R</span>GIFT <span class="bold">S</span>HOP
    </h2>
    <h4 class="sub-title-font-size">
      {{ $t("home.card.subTitle") }}
    </h4>
    <div class="d-flex ga-13 flex-column flex-md-row flex-warp card-container">
      <img class="svg flower-01" src="/images/flowers.svg" />
      <CategoyCard
        :class="[isMobile ? 'order-3' : '']"
        v-for="rootCategorie in rootCategories"
        :title="rootCategorie.title"
        :imgSrc="imageUrl(rootCategorie.image)"
        :content="rootCategorie.description"
        :key="rootCategorie"
        :to="`/${rootCategorie.path}`"
      />
    </div>
    <v-btn :height="60" class="mainColorBtn" to="/products">
      <v-icon
        color="white"
        class="ml-2"
        icon="mdi-cursor-default-click-outline"
      ></v-icon>
      {{ $t("home.card.btn") }}
    </v-btn>
    <img class="svg flower-02" src="/images/flowers.svg" />
  </section>
</template>

<script>
import CategoyCard from "../CategoyCard.vue";
import { mapGetters } from "vuex";
import { getImageUrl } from "../../../utilities";
export default {
  props: {
    rootCategories: {
      type: Array,
      required: true,
    },
  },
  methods: {
    imageUrl(image) {
      return getImageUrl(image, 500 ,500);
    },
  },
  components: {
    CategoyCard,
  },
  computed: {
    ...mapGetters({
      isMobile: "isMobile",
    }),
  },
};
</script>

<style scoped lang="scss">
* {
  text-align: center;
}
section {
  margin-top: 140px !important;
  position: relative;
}
.flower-01 {
  right: -190px;
  top: -155px;
  rotate: -10deg;
}
.flower-02 {
  left: -100px;
  z-index: -1;
  bottom: 0px;
  rotate: 180deg;
}
h2 {
  font-family: Heebo;
  font-size: 35px;
  font-weight: 300;
}
h4 {
  font-family: Heebo;
  font-size: 20px;
  font-weight: 400;
  color: $DeepGray;
  margin-bottom: 50px;
}
.main-color {
  color: $primaryColor;
}
.bold {
  font-weight: 700;
}
.card-container {
  position: relative;
  margin: 0px 75px;
  margin-bottom: 50px;
}
.isTablet,
.isMobile {
  h4 {
    margin-bottom: 20px;
  }
  section {
    margin-top: 70px !important;
  }
  .flower-02 {
    left: -80px;
    bottom: -90px;
    rotate: 344deg;
    z-index: -1;
  }
}
.isMobile {
  .card-container {
    margin: 0px;
    margin-bottom: 20px;
    gap: 30px !important;
  }
  .box {
    overflow: hidden !important;
  }
}
</style>
